import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { PharmacyOrderStatus } from "@/Common/Models/UI/Enums";
import { Icon } from "@/DesignSystem";
import { IconVariant } from "@/DesignSystem/Atoms/Icons/Icon/Icon";
import { Tag } from "@/DesignSystem/Molecules/Tag/Tag";

import Checks from "@/DesignSystem/Atoms/Icons/Types/Checks/checks-regular.svg";
import ClockCountdown from "@/DesignSystem/Atoms/Icons/Types/ClockCountdown/clock-countdown-regular.svg";
import Phone from "@/DesignSystem/Atoms/Icons/Types/Phone/phone-regular.svg";
import Prescription from "@/DesignSystem/Atoms/Icons/Types/Prescription/prescription-regular.svg";
import Warning from "@/DesignSystem/Atoms/Icons/Types/Warning/warning-fill.svg";
import XCircle from "@/DesignSystem/Atoms/Icons/Types/XCircle/x-circle-regular.svg";

interface IPharmacyOrdersStatusViewProps {
    orderStatus: PharmacyOrderStatus | null;
    hasFailedAuthentication?: boolean;
    isAllergiesUpdated?: boolean;
}

const emptyValue = "--";

function PharmacyOrdersStatusView({ orderStatus, hasFailedAuthentication, isAllergiesUpdated }: Readonly<IPharmacyOrdersStatusViewProps>): JSX.Element {
    let iconStyle: { iconType: JSX.Element, variant: IconVariant } | null = null;

    switch (orderStatus) {
        case PharmacyOrderStatus.Contacted:
            iconStyle = { iconType: <ClockCountdown />, variant: "neutral" };
            break;
        case PharmacyOrderStatus.NotContacted:
            iconStyle = { iconType: <Phone />, variant: "error" };
            break;
        case PharmacyOrderStatus.ToPrepare:
            iconStyle = { iconType: <Prescription />, variant: "brand" };
            break;
        case PharmacyOrderStatus.OnHold:
            iconStyle = { iconType: <Prescription />, variant: "warning" };
            break;
        case PharmacyOrderStatus.Completed:
            iconStyle = { iconType: <Checks />, variant: "success" };
            break;
        case PharmacyOrderStatus.Canceled:
            iconStyle = { iconType: <XCircle />, variant: "error" };
            break;
    }

    if (!iconStyle) {
        return <>{emptyValue}</>;
    }

    const { iconType, variant } = iconStyle;
    const label = EnumHelper.getVocab(PharmacyOrderStatus, "Enums_PharmacyOrderStatus_", orderStatus);
    const warningIcon = hasFailedAuthentication || isAllergiesUpdated === false ?
        <span>&nbsp;<Icon size="sm" colorVariant="warning"><Warning /></Icon></span> :
        null;

    return (
        <span>
            <Tag label={label} variant={variant} size="sm">
                {iconType}
            </Tag>
            {warningIcon}
        </span>
    );
}

export { PharmacyOrdersStatusView };
